module.exports = __webpack_public_path__ + "img/game04.70da5194.jpg";